// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserMenu_container__tJlp9 {
  column-gap: 16px;
  cursor: pointer;
  display: flex;
  height: 48px;
}
.UserMenu_userPhoto__4KrlC {
  border: 1px solid #e2e2e2;
  border-radius: 55px;
  height: 44px;
  width: 44px;
}
.UserMenu_userInfoContainer__maOXv {
  display: flex;
  flex-direction: column;
  width: 168px;
}
.UserMenu_userNameText__M3T-3 {
  color: #4d4d4d;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
  text-transform: capitalize;
}
.UserMenu_userRoleText__-zWvg {
  color: #4d4d4d;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
  text-transform: capitalize;
}
.UserMenu_dropdownButton__LUapn {
  align-items: center;
  border: 1px solid transparent;
  display: flex;
  justify-content: center;
  height: 32px;
  transition: all 200ms ease-in-out;
  width: 32px;
}
.UserMenu_dropdownButtonActive__W5Pqj {
  align-items: center;
  border: 1px solid rgba(95, 109, 126, 0.16);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  height: 32px;
  transition: all 200ms ease-in-out;
  width: 32px;
}
.UserMenu_dropdownIcon__gcbLX {
  stroke: #5f6d7e;
}
@media screen and (max-width: 987px) {
  .UserMenu_userInfoContainer__maOXv {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/userMenu/UserMenu.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iCAAiC;EACjC,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iCAAiC;EACjC,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".container {\n  column-gap: 16px;\n  cursor: pointer;\n  display: flex;\n  height: 48px;\n}\n.userPhoto {\n  border: 1px solid #e2e2e2;\n  border-radius: 55px;\n  height: 44px;\n  width: 44px;\n}\n.userInfoContainer {\n  display: flex;\n  flex-direction: column;\n  width: 168px;\n}\n.userNameText {\n  color: #4d4d4d;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  text-transform: capitalize;\n}\n.userRoleText {\n  color: #4d4d4d;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  text-transform: capitalize;\n}\n.dropdownButton {\n  align-items: center;\n  border: 1px solid transparent;\n  display: flex;\n  justify-content: center;\n  height: 32px;\n  transition: all 200ms ease-in-out;\n  width: 32px;\n}\n.dropdownButtonActive {\n  align-items: center;\n  border: 1px solid rgba(95, 109, 126, 0.16);\n  border-radius: 4px;\n  display: flex;\n  justify-content: center;\n  height: 32px;\n  transition: all 200ms ease-in-out;\n  width: 32px;\n}\n.dropdownIcon {\n  stroke: #5f6d7e;\n}\n@media screen and (max-width: 987px) {\n  .userInfoContainer {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UserMenu_container__tJlp9`,
	"userPhoto": `UserMenu_userPhoto__4KrlC`,
	"userInfoContainer": `UserMenu_userInfoContainer__maOXv`,
	"userNameText": `UserMenu_userNameText__M3T-3`,
	"userRoleText": `UserMenu_userRoleText__-zWvg`,
	"dropdownButton": `UserMenu_dropdownButton__LUapn`,
	"dropdownButtonActive": `UserMenu_dropdownButtonActive__W5Pqj`,
	"dropdownIcon": `UserMenu_dropdownIcon__gcbLX`
};
export default ___CSS_LOADER_EXPORT___;
